import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/_teacher-portal/groups/my/faculty')({
    component: Outlet,
    staticData: {
        crumb: {
            label: `My Faculty`
        }
    }
})